import React from 'react';
import './styles.scss';

export default function Header() {
  return (
      <header>
        <h1>Memory Game</h1>
      </header>
  );
}
